import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';
import { flatMap, map } from 'rxjs/operators';

@Injectable()
export class InstallationPartyBccBsaPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService
  ) {
    super(apiService, dataService, null, inspectionFactory);
  }

  public updateBccBsa(inspectionId: string, pointId: string, pluginId: string, bccBsa: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, bccBsa).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, bccBsa: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, bccBsa, 'PartyBccBsa').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
